// Country list source: https://www.dhl.com/en/country_profile.html#.XwODEJNKjOQ
// Country iso3166alpha2iation source: https://planetarynames.wr.usgs.gov/iso3166alpha2iations
// Postal code: https://gist.githubusercontent.com/jamesbar2/1c677c22df8f21e869cca7e439fc3f5b/raw/21662445653ac861f8ab81caa8cfaee3185aed15/postal-codes.json
// Postal code: https://en.wikipedia.org/wiki/List_of_postal_codes

// Country/territory items with no postal code regexes or ranges either do not require postal codes
// or there may not be enough information for that country/territory

module.exports = [
  {
    iso3166alpha2: 'AF',
    name: 'Afghanistan',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'AL',
    name: 'Albania',
    postal: /^(120|122)[0-9]{2}$/g,
  },
  {
    iso3166alpha2: 'DZ',
    name: 'Algeria',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'AS',
    name: 'American Samoa',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'AD',
    name: 'Andorra',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'AO',
    name: 'Angola',
  },
  {
    iso3166alpha2: 'AI',
    name: 'Anguilla',
    postal: /^AI-2640$/g,
  },
  {
    iso3166alpha2: 'AG',
    name: 'Antigua and Barbuda',
  },
  {
    iso3166alpha2: 'AR',
    name: 'Argentina',
    postal: /^([A-Z][0-9]{4}[A-Z]{3}|[0-9]{4})$/g,
  },
  {
    iso3166alpha2: 'AM',
    name: 'Armenia',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'AW',
    name: 'Aruba',
  },
  {
    iso3166alpha2: 'AU',
    name: 'Australia',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'AT',
    name: 'Austria',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'AZ',
    name: 'Azerbaijan',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'BS',
    name: 'Bahamas',
  },
  {
    iso3166alpha2: 'BH',
    name: 'Bahrain',
  },
  {
    iso3166alpha2: 'BD',
    name: 'Bangladesh',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'BB',
    name: 'Barbados',
    postal: /^BB[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'BY',
    name: 'Belarus',
    postal: /^[0-9]{6}$/g,
  },
  {
    iso3166alpha2: 'BE',
    name: 'Belgium',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'BZ',
    name: 'Belize',
  },
  {
    iso3166alpha2: 'BJ',
    name: 'Benin',
  },
  {
    iso3166alpha2: 'BM',
    name: 'Bermuda',
    postal: /^[A-Z]{2}[0-9]{2}$/g,
  },
  {
    iso3166alpha2: 'BT',
    name: 'Bhutan',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'BO',
    name: 'Bolivia',
  },
  {
    iso3166alpha2: 'BQ',
    name: 'Bonaire',
  },
  {
    iso3166alpha2: 'BA',
    name: 'Bosnia and Herzegovina',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'BW',
    name: 'Botswana',
  },
  {
    iso3166alpha2: 'BR',
    name: 'Brazil',
    postal: /^[0-9]{5}-[0-9]{3}$/g,
  },
  {
    iso3166alpha2: 'BN',
    name: 'Brunei',
    postal: /^[A-Z]{2}[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'BG',
    name: 'Bulgaria',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'BF',
    name: 'Burkina Faso',
  },
  {
    iso3166alpha2: 'BI',
    name: 'Burundi',
  },
  {
    iso3166alpha2: 'KH',
    name: 'Cambodia',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'CM',
    name: 'Cameroon',
  },
  {
    iso3166alpha2: 'CA',
    name: 'Canada',
    postal: /^[A-Z][0-9][A-Z] ?[0-9][A-Z][0-9]$/g,
  },
  {
    iso3166alpha2: 'CI',
    name: 'Canary Islands',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'CV',
    name: 'Cape Verde',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'KY',
    name: 'Cayman Islands',
    postal: /^[A-Z]{2}[0-9]-[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'CF',
    name: 'Central African Republic',
  },
  {
    iso3166alpha2: 'TD',
    name: 'Chad',
  },
  {
    iso3166alpha2: 'CI',
    name: 'Channel Islands',
    postal: /^[A-Z]{2}[0-9]{2}$/g,
  },
  {
    iso3166alpha2: 'CL',
    name: 'Chile',
    postal: /^[0-9]{7}$/g,
  },
  {
    iso3166alpha2: 'CN',
    name: "China, People's Republic",
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'CO',
    name: 'Colombia',
    postal: /^[0-9]{6}$/g,
  },
  {
    iso3166alpha2: 'KM',
    name: 'Comoros',
  },
  {
    iso3166alpha2: 'CG',
    name: 'Congo',
  },
  {
    iso3166alpha2: 'CD',
    name: 'Congo, The Democratic Republic of',
  },
  {
    iso3166alpha2: 'CK',
    name: 'Cook Islands',
  },
  {
    iso3166alpha2: 'CR',
    name: 'Costa Rica',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'CI',
    name: "Côte d'Ivoire",
  },
  {
    iso3166alpha2: 'HR',
    name: 'Croatia',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'CU',
    name: 'Cuba',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'CW',
    name: 'Curacao',
  },
  {
    iso3166alpha2: 'CY',
    name: 'Cyprus',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'CZ',
    name: 'Czech Republic',
    postal: /^[0-9]{3} [0-9]{2}$/g,
  },
  {
    iso3166alpha2: 'DK',
    name: 'Denmark',
    postal: /^[0-9]{4,5}$/g,
  },
  {
    iso3166alpha2: 'DJ',
    name: 'Djibouti',
  },
  {
    iso3166alpha2: 'DM',
    name: 'Dominica',
  },
  {
    iso3166alpha2: 'DO',
    name: 'Dominican Republic',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'TL',
    name: 'East Timor',
  },
  {
    iso3166alpha2: 'EC',
    name: 'Ecuador',
    postal: /^[0-9]{6}$/g,
  },
  {
    iso3166alpha2: 'EG',
    name: 'Egypt',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'SV',
    name: 'El Salvador',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'ER',
    name: 'Eritrea',
  },
  {
    iso3166alpha2: 'EE',
    name: 'Estonia',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'ET',
    name: 'Ethiopia',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'FK',
    name: 'Falkland Islands',
    postal: /^FIQQ 1ZZ$/g,
  },
  {
    iso3166alpha2: 'FO',
    name: 'Faroe Islands',
    postal: /^[0-9]{3}$/g,
  },
  {
    iso3166alpha2: 'FJ',
    name: 'Fiji',
  },
  {
    iso3166alpha2: 'FI',
    name: 'Finland',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'FR',
    name: 'France',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'PF',
    name: 'French Polynesia',
    postal: /^987[0-9]{2}$/g,
    range: ['98700', '98790'],
  },
  {
    iso3166alpha2: 'GA',
    name: 'Gabon',
  },
  {
    iso3166alpha2: 'GM',
    name: 'Gambia',
  },
  {
    iso3166alpha2: 'GE',
    name: 'Georgia',
  },
  {
    iso3166alpha2: 'DE',
    name: 'Germany',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'GH',
    name: 'Ghana',
  },
  {
    iso3166alpha2: 'GI',
    name: 'Gibraltar',
    postal: /^GX11 1AA$/g,
  },
  {
    iso3166alpha2: 'GR',
    name: 'Greece',
    postal: /^[0-9]{3} [0-9]{2}$/g,
  },
  {
    iso3166alpha2: 'GL',
    name: 'Greenland',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'GD',
    name: 'Grenada',
  },
  {
    iso3166alpha2: 'GP',
    name: 'Guadeloupe',
    postal: /^971[0-9]{2}$/g,
    range: ['97100', '97190'],
  },
  {
    iso3166alpha2: 'GU',
    name: 'Guam',
    // US postal code
    // https://stackoverflow.com/questions/2577236/regex-for-zip-code
    postal: /^^\d{5}(?:[-\s]\d{4})?$$/g,
    range: ['96910', '96932'],
  },
  {
    iso3166alpha2: 'GT',
    name: 'Guatemala',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'GG',
    name: 'Guernsey',
    // UK postal code
    // https://stackoverflow.com/questions/164979/regex-for-matching-uk-postcodes
    postal:
      /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/g,
  },
  {
    iso3166alpha2: 'GW',
    name: 'Guinea-Bissau',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'GQ',
    name: 'Guinea-Equatorial',
  },
  {
    iso3166alpha2: 'GN',
    name: 'Guinea Republic',
    postal: /^[0-9]{3}$/g,
  },
  {
    iso3166alpha2: 'GY',
    name: 'Guyana (British)',
  },
  {
    iso3166alpha2: 'GF',
    name: 'Guyana (French)',
    postal: /^973[0-9]{2}$/g,
    range: ['97300', '97390'],
  },
  {
    iso3166alpha2: 'HT',
    name: 'Haiti',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'HN',
    name: 'Honduras',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'HK',
    name: 'Hong Kong',
  },
  {
    iso3166alpha2: 'HU',
    name: 'Hungary',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'IS',
    name: 'Iceland',
    postal: /^[0-9]{3}$/g,
  },
  {
    iso3166alpha2: 'IN',
    name: 'India',
    // https://stackoverflow.com/questions/33865525/indian-pincode-validation-regex-only-six-digits-shouldnt-start-with-0
    postal: /^^[1-9][0-9]{5}$$/g,
  },
  {
    iso3166alpha2: 'ID',
    name: 'Indonesia',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'IR',
    name: 'Iran',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'IQ',
    name: 'Iraq',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'IE',
    name: 'Ireland, Republic of',
    // https://stackoverflow.com/questions/33391412/validation-for-irish-eircode
    postal: /^(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$$/g,
  },
  {
    iso3166alpha2: 'FK',
    name: 'Islas Malvinas',
    postal: /^FIQQ 1ZZ$/g,
  },
  {
    iso3166alpha2: 'IL',
    name: 'Israel',
    postal: /^[0-9]{5}|[0-9]{7}$/g,
  },
  {
    iso3166alpha2: 'IT',
    name: 'Italy',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'CI',
    name: 'Ivory Coast',
  },
  {
    iso3166alpha2: 'JM',
    name: 'Jamaica',
  },
  {
    iso3166alpha2: 'JP',
    name: 'Japan',
    postal: /^[0-9]{3}-[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'JE',
    name: 'Jersey',
    postal:
      /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/g,
  },
  {
    iso3166alpha2: 'JO',
    name: 'Jordan',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'KZ',
    name: 'Kazakhstan',
    postal: /^[0-9]{6}$/g,
  },
  {
    iso3166alpha2: 'KE',
    name: 'Kenya',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'KI',
    name: 'Kiribati',
  },
  {
    iso3166alpha2: 'KR',
    name: 'Korea, Republic of',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'KP',
    name: 'Korea, The D.P.R of',
  },
  {
    iso3166alpha2: 'XK',
    name: 'Kosovo',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'KW',
    name: 'Kuwait',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'KG',
    name: 'Kyrgyzstan',
    postal: /^[0-9]{6}$/g,
  },
  {
    iso3166alpha2: 'LA',
    name: 'Laos',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'LV',
    name: 'Latvia',
    postal: /^LV-[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'LB',
    name: 'Lebanon',
    postal: /^[0-9]{4} [0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'LS',
    name: 'Lesotho',
    postal: /^[0-9]{3}$/g,
  },
  {
    iso3166alpha2: 'LR',
    name: 'Liberia',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'LY',
    name: 'Libya',
  },
  {
    iso3166alpha2: 'LI',
    name: 'Liechtenstein',
    postal: /^[0-9]{4}$/g,
    range: ['9485', '9498'],
  },
  {
    iso3166alpha2: 'LT',
    name: 'Lithuania',
    postal: /^LT-[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'LU',
    name: 'Luxembourg',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'MO',
    name: 'Macau',
  },
  {
    iso3166alpha2: 'MK',
    name: 'Macedonia, Republic of',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'MG',
    name: 'Madagascar',
    postal: /^[0-9]{3}$/g,
  },
  {
    iso3166alpha2: 'MW',
    name: 'Malawi',
  },
  {
    iso3166alpha2: 'MY',
    name: 'Malaysia',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'MV',
    name: 'Maldives',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'ML',
    name: 'Mali',
  },
  {
    iso3166alpha2: 'MT',
    name: 'Malta',
    postal: /^[A-Z]{3} [0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'MH',
    name: 'Marshall Islands',
    postal: /^^\d{5}(?:[-\s]\d{4})?$$/g,
    range: ['96960', '96970'],
  },
  {
    iso3166alpha2: 'MQ',
    name: 'Martinique',
    postal: /^972[0-9]{2}$/g,
    range: ['97200', '97290'],
  },
  {
    iso3166alpha2: 'MR',
    name: 'Mauritania',
  },
  {
    iso3166alpha2: 'MU',
    name: 'Mauritius',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'YT',
    name: 'Mayotte',
    postal: /^976[0-9]{2}$/g,
    range: ['97600', '97690'],
  },
  {
    iso3166alpha2: 'MX',
    name: 'Mexico',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'MD',
    name: 'Moldova, Republic of',
    postal: /^MD-?[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'MC',
    name: 'Monaco',
    postal: /^980[0-9]{2}$/g,
  },
  {
    iso3166alpha2: 'MN',
    name: 'Mongolia',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'ME',
    name: 'Montenegro',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'MS',
    name: 'Montserrat',
    postal: /^MSR [0-9]{4}$/g,
    range: ['MSR 1110', 'MSR 1350'],
  },
  {
    iso3166alpha2: 'MA',
    name: 'Morocco',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'MZ',
    name: 'Mozambique',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'MM',
    name: 'Myanmar',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'NA',
    name: 'Namibia',
  },
  {
    iso3166alpha2: 'NR',
    name: 'Nauru',
  },
  {
    iso3166alpha2: 'NP',
    name: 'Nepal',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'NL',
    name: 'Netherlands',
    // https://rgxdb.com/r/4W9GV8AC
    postal: /^^(?:NL-)?(\d{4})\s*([A-Z]{2})$/i,
  },
  {
    iso3166alpha2: 'NC',
    name: 'New Caledonia',
    postal: /^988[0-9]{2}$/g,
    range: ['96950', '96952'],
  },
  {
    iso3166alpha2: 'NZ',
    name: 'New Zealand',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'NI',
    name: 'Nicaragua',
  },
  {
    iso3166alpha2: 'NE',
    name: 'Niger',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'NG',
    name: 'Nigeria',
    postal: /^[0-9]{6}$/g,
  },
  {
    iso3166alpha2: 'NU',
    name: 'Niue',
  },
  {
    iso3166alpha2: 'MP',
    name: 'Northern Mariana Islands',
    postal: /^^\d{5}(?:[-\s]\d{4})?$$/g,
  },
  {
    iso3166alpha2: 'NO',
    name: 'Norway',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'OM',
    name: 'Oman',
    postal: /^[0-9]{3}$/g,
  },
  {
    iso3166alpha2: 'PK',
    name: 'Pakistan',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'PW',
    name: 'Palau',
    postal: /^^\d{5}(?:[-\s]\d{4})?$$/g,
  },
  {
    iso3166alpha2: 'PA',
    name: 'Panama',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'PG',
    name: 'Papua New Guinea',
    postal: /^[0-9]{3}$/g,
  },
  {
    iso3166alpha2: 'PY',
    name: 'Paraguay',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'PE',
    name: 'Peru',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'PH',
    name: 'Philippines',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'PL',
    name: 'Poland',
    postal: /^[0-9]{2}-[0-9]{3}$/g,
  },
  {
    iso3166alpha2: 'PT',
    name: 'Portugal',
    postal: /^[0-9]{4}-[0-9]{3}$/g,
  },
  {
    iso3166alpha2: 'PR',
    name: 'Puerto Rico',
    postal: /^^\d{5}(?:[-\s]\d{4})?$$/g,
  },
  {
    iso3166alpha2: 'QA',
    name: 'Qatar',
  },
  {
    iso3166alpha2: 'RE',
    name: 'Réunion',
    postal: /^974[0-9]{2}$/g,
    range: ['97400', '97490'],
  },
  {
    iso3166alpha2: 'RO',
    name: 'Romania',
    postal: /^[0-9]{6}$/g,
  },
  {
    iso3166alpha2: 'RU',
    name: 'Russian Federation',
    postal: /^[0-9]{6}$/g,
  },
  {
    iso3166alpha2: 'RW',
    name: 'Rwanda',
  },
  {
    iso3166alpha2: 'MP',
    name: 'Saipan',
    postal: /^96950$/g,
  },
  {
    iso3166alpha2: 'WS',
    name: 'Samoa',
    postal: /^WS[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'ST',
    name: 'Sao Tome and Principe',
  },
  {
    iso3166alpha2: 'SA',
    name: 'Saudi Arabia',
    postal: /^[0-9]{5}(-[0-9]{4})?$/g,
  },
  {
    iso3166alpha2: 'SN',
    name: 'Senegal',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'RS',
    name: 'Serbia',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'SC',
    name: 'Seychelles',
  },
  {
    iso3166alpha2: 'SL',
    name: 'Sierra Leone',
  },
  {
    iso3166alpha2: 'SG',
    name: 'Singapore',
    postal: /^[0-9]{6}$/g,
  },
  {
    iso3166alpha2: 'SK',
    name: 'Slovakia',
    postal: /^[0-9]{3} [0-9]{2}$/g,
  },
  {
    iso3166alpha2: 'SI',
    name: 'Slovenia',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'SB',
    name: 'Solomon Islands',
  },
  {
    iso3166alpha2: 'SO',
    name: 'Somalia',
    postal: /^[A-Z]{2} [0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'ZA',
    name: 'South Africa',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'SS',
    name: 'South Sudan',
  },
  {
    iso3166alpha2: 'ES',
    name: 'Spain',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'LK',
    name: 'Sri Lanka',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'BL',
    name: 'St. Barthélemy',
    postal: /^[0-9]{5}$/g,
    range: ['97100', '97190'],
  },
  {
    iso3166alpha2: 'VI',
    name: 'St. Croix',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'SE',
    name: 'St. Eustatius',
  },
  {
    iso3166alpha2: 'SH',
    name: 'St. Helena',
    postal: /^STHL 1ZZ$/g,
  },
  {
    iso3166alpha2: 'AG',
    name: 'St. John',
    postal: /^^\d{5}(?:[-\s]\d{4})?$$/g,
  },
  {
    iso3166alpha2: 'KN',
    name: 'St. Kitts and Nevis',
    postal: /^[A-Z]{2}[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'LC',
    name: 'St. Lucia',
    postal: /^[A-Z]{2}[0-9]{2} [0-9]{3}$/g,
  },
  {
    iso3166alpha2: 'SX',
    name: 'St. Maarten',
  },
  {
    iso3166alpha2: 'VI',
    name: 'St. Thomas',
  },
  {
    iso3166alpha2: 'VC',
    name: 'St. Vincent and the Grenadines',
    postal: /^VC[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'SD',
    name: 'Sudan',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'SR',
    name: 'Suriname',
  },
  {
    iso3166alpha2: 'SZ',
    name: 'Swaziland',
    postal: /^[A-Z]{1}[0-9]{3}$/g,
  },
  {
    iso3166alpha2: 'SE',
    name: 'Sweden',
    postal: /^[0-9]{3} [0-9]{2}$/g,
  },
  {
    iso3166alpha2: 'CH',
    name: 'Switzerland',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'SY',
    name: 'Syria',
  },
  {
    iso3166alpha2: 'PF',
    name: 'Tahiti',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'TW',
    name: 'Taiwan',
    postal: /^[0-9]{3}(-[0-9]{2})?$/g,
  },
  {
    iso3166alpha2: 'TZ',
    name: 'Tanzania',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'TH',
    name: 'Thailand',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'TG',
    name: 'Togo',
  },
  {
    iso3166alpha2: 'TO',
    name: 'Tonga',
  },
  {
    iso3166alpha2: 'VG',
    name: 'Tortola',
    postal: /^VG[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'TT',
    name: 'Trinidad and Tobago',
    postal: /^[0-9]{6}$/g,
  },
  {
    iso3166alpha2: 'TN',
    name: 'Tunisia',
    postal: /^[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'TR',
    name: 'Turkey',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'TM',
    name: 'Turkmenistan',
    postal: /^[0-9]{6}$/g,
  },
  {
    iso3166alpha2: 'TC',
    name: 'Turks and Caicos Islands',
    postal: /^TKCA 1ZZ$/g,
  },
  {
    iso3166alpha2: 'TV',
    name: 'Tuvalu',
  },
  {
    iso3166alpha2: 'UG',
    name: 'Uganda',
  },
  {
    iso3166alpha2: 'UA',
    name: 'Ukraine',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'AE',
    name: 'United Arab Emirates',
  },
  {
    iso3166alpha2: 'GB',
    name: 'United Kingdom',
    postal:
      /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/g,
  },
  {
    iso3166alpha2: 'US',
    name: 'United States of America',
    postal: /^^\d{5}(?:[-\s]\d{4})?$$/g,
  },
  {
    iso3166alpha2: 'UY',
    name: 'Uruguay',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'UZ',
    name: 'Uzbekistan',
    postal: /^[0-9]{6}$/g,
  },
  {
    iso3166alpha2: 'VU',
    name: 'Vanuatu',
  },
  {
    iso3166alpha2: 'VE',
    name: 'Venezuela',
    postal: /^[0-9]{4}(-[A-Z]{1})?$/g,
  },
  {
    iso3166alpha2: 'VN',
    name: 'Vietnam',
    postal: /^[0-9]{6}$/g,
  },
  {
    iso3166alpha2: 'VG',
    name: 'Virgin Islands (British)',
    postal: /^VG[0-9]{4}$/g,
  },
  {
    iso3166alpha2: 'VI',
    name: 'Virgin Islands (US)',
    range: ['00801', '00851'],
    postal: /^^\d{5}(?:[-\s]\d{4})?$$/g,
  },
  {
    iso3166alpha2: 'YE',
    name: 'Yemen',
  },
  {
    iso3166alpha2: 'ZM',
    name: 'Zambia',
    postal: /^[0-9]{5}$/g,
  },
  {
    iso3166alpha2: 'ZW',
    name: 'Zimbabwe',
  },
];
